import { useMemo } from 'react';

import { useMenu } from 'global/MenuContext';
import { SOLUTIONS_MENU_ITEMS, SolutionMenuItem } from 'types/solutionsTypes';

export const useSolutionsMenu = () => {
  const { sideMenu } = useMenu();

  const activeSolutions = useMemo(() => {
    if (!sideMenu?.solutions) return [];

    const solutions = sideMenu.solutions;
    const activeItems: SolutionMenuItem[] = [];

    Object.entries(SOLUTIONS_MENU_ITEMS).forEach(([key, item]) => {
      if (solutions[key as keyof typeof solutions]) {
        activeItems.push({
          ...item,
          isActive: true,
        });
      }
    });

    return activeItems;
  }, [sideMenu]);

  const hasActiveSolutions = useMemo(() => {
    return activeSolutions.length > 0;
  }, [activeSolutions]);

  return {
    activeSolutions,
    hasActiveSolutions,
  };
};
